import { useFetchCb } from '@gluedigital/ruse-fetch-extras'
import { AUTH_URL } from 'src/constants/global'

export default function useAuth() {
  const doFetch = useFetchCb()

  const requestEmail = async (email: string) => {
    return await doFetch(AUTH_URL + '/auth/magic-link', {
      method: 'POST',
      body: { email, app: 'admin' }
    })
  }

  return { requestEmail }
}
